import type { RequestScopes } from "@aschehoug/aschehoug-oidc-client"
import { AschehougOidcClient } from "@aschehoug/aschehoug-oidc-client"

export function useOidcClient() {
  const origin = useCurrentOrigin()

  const { id, oauth, core } = useRuntimeConfig().public

  return new AschehougOidcClient({
    authority: id.authority,
    client_id: id.clientId,
    scope: "openid profile email" as RequestScopes.openIdProfile,
    redirect_uri: origin,
    redirect_feide_uri: oauth.redirectURL,
    post_logout_redirect_uri: origin,
    response_type: "code",
    metadata: {
      authorization_endpoint: id.authEndpoint,
    },
    base_uri_am: id.baseUrl,
    selfService_api_url: core.api,
    idCloudUrl: id.cloud,
  })
}
